import { ProgramAPI } from '@/api'

export default {

  namespaced: true,

  state: {
    selected_step: null,
    current_step: null,
  },


  mutations: {

    setCurrentStep(state, step) {
      state.current_step = step;
    },

    setSelectedStep(state, step) {
      state.selected_step = step;
    },
  },

  actions: {

    /**
     *
     * @param {*} param0
     * @param {String} key
     */
    setCurrentStep({ commit, rootGetters }, step) {
      if(rootGetters['program/data'].finished == 0) {
        commit('setCurrentStep', step);
        return ProgramAPI.setProgramStep({
          step: step,
          programId: rootGetters['program/data'].id,
        });
      }
    },

    async goToNextStep({ state, commit, dispatch, getters }) {
      const next_step = getters.getNextStep();

      if(next_step) {
        await dispatch('goToStep', next_step);
      }
    },

    async goToPrevStep({ state, getters, commit, dispatch }) {
      const prev_step = getters.getPrevStep();
      // console.log(prev_step);

      if(prev_step) {
        await dispatch('goToStep', prev_step);
      }
    },


    /**
     *
     * @param {*} param0
     * @param {*} step
     */
    goToStep({ state, commit, dispatch, getters }, step) {

      // если обработка доступных степов будет на стороне сервера
      // то здесь надо будет подгружать программу с async/await

      // await dispatch('execHooks');

      const step_availablity = getters.data.find(n => n.key === step);

      if(step_availablity.available && step_availablity.active) {
        commit('setSelectedStep', step);
      }
    },
  },

  getters: {

    selected(state) {
      return state.selected_step;
    },

    getNextStep: (state, getters) => step => {
      step = step || state.selected_step;
      const steps = getters.data;
      const index = steps.findIndex(n => n.key === step);
      const item = steps.find((n, i) => i > index && n.available);
      if(item) {
        return item.key;
      }
    },

    getPrevStep: (state, getters) => step => {
      step = step || state.selected_step;
      const steps = getters.data;
      const index = steps.findIndex(n => n.key === step);
      // const step = steps[index - 1];

      const result = steps.filter((n, i) => i < index && n.available);
      const item = result[result.length - 1];

      if(item) {
        return item.key;
      }
    },

    current(state) {
      return state.current_step;
    },

    isTestsStepAvailable(state, getters, rootState, rootGetters) {

      const program = rootGetters['program/data'];

      return !!(program.tissueTest || program.waterTest || program.soilTest || program.mediaAnalysis);
    },

    data(state, getters, rootState, rootGetters) {

      const program = rootGetters['program/data'];

      let steps = [
        {
          key: 'general-settings',
          available: true,
          active: true,
        },
        {
          key: 'gdd',
          available: program.gdd,
          active: true,
        },
        {
          key: 'tests',
          available: getters.isTestsStepAvailable,
          active: false,
        },
        {
          key: 'liming',
          // available: true,
          available: program.liming,
          active: false,
        },
        {
          key: 'base-dressing',
          available: program.baseDressing,
          active: false,
        },
        {
          key: 'adjusted-values',
          available: true,
          active: false,
        },
        {
          key: 'fertilizer-schedule',
          available: true,
          active: false,
        },
        {
          key: 'fertigation',
          available: program.fertigation !== "0" && program.fertigation !== 0,
          active: false,
        },
        {
          key: 'blend',
          available: !!program.blend,
          active: false,
        },
        {
          key: 'result',
          available: true,
          active: false,
        },
      ];

      let index = steps.findIndex(n => n.key === state.current_step);
      if(index < 0) {
        steps.forEach(n => {
          n.active = n.key === 'general-settings';
        });
      } else {
        for (const i in steps) {
          if(i <= index) {
            steps[i].active = true;
          } else {
            if(i > index && steps[i].available) {
              steps[i].active = true;
              break;
            }
          }
        }
      }

      return steps;
    }
  },
}
